import React from "react";
import PricingListPage from "./PricingListPage";
import { useParams } from "react-router-dom";

export interface PricingListForTenderProps {
	maximized?: boolean;
}

export function PricingListForTender(
	props: Readonly<PricingListForTenderProps>
) {
	const { tenderId } = useParams();
	return (
		<PricingListPage
			maximized={props.maximized}
			tenderId={parseInt(tenderId || "0")}
		/>
	);
}
